import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./authConfig";
import * as ReactDOMClient from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import axiosInstance from "./axiosInstanvce";
import React from "react";
import App from "./App";

const msalInstance = new PublicClientApplication(msalConfig);

const initializeMsal = async () => {
  try {
    // Explicitly call initialize
    await msalInstance.initialize();

    // Handle redirect responses first
    await msalInstance.handleRedirectPromise();

    // Check if there is an active account
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      // No account is signed in, redirect to SSO login
      return msalInstance.loginRedirect(loginRequest);
    } else {
      // Set the first account as active
      msalInstance.setActiveAccount(accounts[0]);

      // Acquire a token silently
      const tokenResponse = await msalInstance.acquireTokenSilent(loginRequest);
      const accessToken = tokenResponse.accessToken;

      // add token to axios
      axiosInstance.defaults.headers.Authorization = `Bearer ${accessToken}`;
      // console.log("Bearer: ", accessToken);
    }
  } catch (error) {
    console.error("MSAL initialization error: ", error);
    // Optionally handle errors like redirecting to login if silent token acquisition fails
  }
};

const renderApp = () => {
  const rootElement = document.getElementById("root");
  const root = ReactDOMClient.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App msalInstance={msalInstance} />
      </MsalProvider>
    </React.StrictMode>
  );
};

// Call initializeMsal, then render the app once initialization completes
initializeMsal()
  .then(() => {
    renderApp(); // Render the app only after initialization is complete and credentials are gathered
  })
  .catch((error) => {
    console.error("Error during MSAL initialization:", error);
    renderApp(); // Optionally render the app with error handling
  });
